// https://www.windcave.com/developer-ecommerce-google-pay#merchant_hosted_payment_page
// https://developers.google.com/pay/api/web/guides/tutorial
import { Inject, Injectable } from '@angular/core';

import * as Tokens from '@shared/core/tokens';

import { WindcaveGooglePayService } from './windcave-google-pay.service';
import { StripeGooglePayService } from './stripe-google-pay.service';

@Injectable({
    providedIn: 'root',
})
export class GooglePayPaymentProviderService {
    constructor(
        @Inject(Tokens.CONFIG_TOKEN) private readonly _config: OLO.Config,
        private _windcaveService: WindcaveGooglePayService,
        private _stripeService: StripeGooglePayService,
    ) {}

    public getGooglePayService(): WindcaveGooglePayService | StripeGooglePayService {
        switch (this._config.payments.googlePay.gateway) {
            case 'windcave':
                return this._windcaveService;
            case 'stripe':
                return this._stripeService;
            default:
                throw new Error(`Unsupported gateway: ${this._config.payments.googlePay.gateway}`);
        }
    }
}
